import { Component,OnInit,OnDestroy,AfterViewInit,Input } from '@angular/core';
import { takeWhile } from "rxjs/operators";
import { Router,ActivatedRoute,ParamMap,NavigationExtras } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import {
    FvmsCommonService
    ,FvmsApiDtgCarService
    ,FvmsApiAuthService
} from "src/app/shared/service";
import {
    DtgListType
    ,PagingInfo
} from "src/app/shared/vo";
import { DtgManageCarExtAcceptModalSearchCompanyComponent }
from "src/app/dtg/manage/car/ext/accept/modal";

@Component({
    selector: "dtg-manage-car-ext-accept-list"
    ,templateUrl: './dtg.manage.car.ext.accept.list.component.html'
    ,styleUrls: ["./dtg.manage.car.ext.accept.list.component.scss"]
    ,providers: []
})
export class DtgManageCarExtAcceptListComponent implements OnInit,OnDestroy,AfterViewInit {
    isContinue:boolean = true;
    companyInfo:any;
    currentCarInfo:any;
    currentUserInfo:any;
    userGroupId:number;
    dtgUnitId:string;
    DtgListType = DtgListType;
    @Input() listType:any = DtgListType.list;
    pagingInfo:PagingInfo = new PagingInfo();
    searchInfo:any = {};
    listItem:any[];
    searchValue:string;

    constructor(
        private fvmsCommonService:FvmsCommonService
        ,private fvmsApiDtgCarService:FvmsApiDtgCarService
        ,private activatedRoute:ActivatedRoute
        ,private router:Router
        ,private modalService:NgbModal
        ,private fvmsApiAuthService:FvmsApiAuthService
    ) {
        this.companyInfo = this.fvmsCommonService.getCompanyInfo();
        this.pagingInfo.pageSize = 15;
        this.dtgUnitId = this.activatedRoute.snapshot.params.dtgUnitId;
        this.currentUserInfo = this.fvmsApiAuthService.getLoginUserInfo();
        this.userGroupId = parseInt(this.currentUserInfo.userGroupId);
        this.fvmsCommonService.subscribeCompanyInfo()
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(companyInfo => {
                if(companyInfo && this.companyInfo){
                    if(this.companyInfo.companyId !== companyInfo.companyId){
                        //회사가 바뀌면 차량 목록이 다르므로 메인 페이지로 이동해야 함
                        let tmpParam = {
                            runtime:new Date().getTime()
                        };
                        let navigationExtras:NavigationExtras = {
                            queryParams:tmpParam
                        };
                        this.router.navigate(["/dtg/manage/car/main"],navigationExtras);
                    }
                }else{
                    this.companyInfo = companyInfo;
                }
            });
     }

    ngOnInit() {
        this.getCarDetail();
        this.reloadListItems();
    }

    ngOnDestroy() {
        this.isContinue = false;
    }
    
    ngAfterViewInit() {

    }

    reloadListItems(){
        this.searchInfo = {
            companyId:this.companyInfo.companyId
            ,dtgUnitId:this.dtgUnitId
        };
        this.fvmsApiDtgCarService.findAllCarExtAccept(this.searchInfo,this.pagingInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.listItem = apiResponse.resultValue;
                    this.pagingInfo = apiResponse.pagingInfo;
                }
            });
    }

    getCarDetail(){
        let searchInfo = {
            companyId:this.companyInfo.companyId
            ,dtgUnitId:this.dtgUnitId
        };
        this.fvmsApiDtgCarService.getCarDetail(searchInfo)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    this.currentCarInfo = apiResponse.resultValue;
                    // let title = `${this.currentCarInfo.dtgCarNo} 의 차량외부표시관리`;
                    // console.log("reloadListItem",title);
                    // let routeData = this.activatedRoute.snapshot.data;
                    // routeData.title = title;
                }
            });
    }

    callbackClickPageNumber(pageNo: number) {
        this.pagingInfo.curPage=pageNo;
        this.reloadListItems();
    }

    callbackChangeCountRowPerPage(pageSize:number){
        this.pagingInfo.pageSize = pageSize;
        this.callbackClickPageNumber(1);
    }

    clickSearch(){
        this.reloadListItems();
    }

    //검색어 입력란에 엔터키 누르면 실행
    keyupEnterSearchValue(e){
        this.reloadListItems();
    }

    changeUseYn(e){
        console.log("changeUseYn",e.useYn,e);
        this.fvmsApiDtgCarService.upsertDeviceCompanyExtAccept(e)
            .pipe(takeWhile(() => this.isContinue))
            .subscribe(apiResponse => {
                if(apiResponse.resultStatus === "ok"){
                    
                }
            });
    }

    clickAddCompany(){
        let modalRef = this.modalService.open(
            DtgManageCarExtAcceptModalSearchCompanyComponent
            ,{
                centered:true
                ,size: "sm"
                ,backdrop:"static"
                //windowClass: "dark-modal"
                ,scrollable: true
            }
        );
        modalRef.componentInstance.dtgUnitId = this.dtgUnitId;

        modalRef.result.then((resultModal) => {
            if(resultModal.result === "ok"){
                this.reloadListItems();
            }
        });
    }
}